import { SeoMetaType } from '@models/common';

export const defaultSeo: SeoMetaType = {
  title: 'W컨셉(W CONCEPT)',
  description: '나만의 컨셉, 감각적 스타일링 - W컨셉',
  openGraph: {
    type: 'website',
    locale: 'ko_KR',
    url: 'https://m.wconcept.co.kr', // 카카오톡, 페이스북에 링크 넣으면 연결되는 url
    title: 'W컨셉(W CONCEPT)', // 카카오톡, 페이스북에 링크 넣으면 올라올 title
    description: '나만의 컨셉, 감각적 스타일링 - W컨셉',
    site_name: 'W Concept', // 카카오나 페이북에 표시될 site_name
    images: [
      // 카카오톡, 페이스북에에 링크 넣으면 올라올 이미지
      {
        width: 800,
        height: 600,
        url: 'https://static.wconcept.co.kr/favicon/touch-icon-ipad-retina.png',
      },
    ],
  },
};
